module.exports = __webpack_public_path__ + "static/media/termsImg_1.4378bc84.jpg";